module.exports = __webpack_public_path__ + "static/media/photobook-asanov-header.6ea8ed50.jpg";